'use strict';
module.exports = function (a, b) {
  try {
    // eslint-disable-next-line no-console -- safe
    arguments.length === 1 ? console.error(a) : console.error(a, b);
  } catch (error) { /* empty */ }
};



//////////////////
// WEBPACK FOOTER
// ./~/core-js-pure/internals/host-report-errors.js
// module id = 670
// module chunks = 13